import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { DailyJournalEntry } from '../../models/daily-journal-entry';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-daily-journal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './daily-journal.component.html',
  styleUrls: ['./daily-journal.component.scss']
})
export class DailyJournalComponent implements OnInit {
  entries: DailyJournalEntry[] = [];
  entryDate = this.today();
  entryText = '';
  errorMessage = '';

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    void this.loadEntries();
  }

  async loadEntries(): Promise<void> {
    this.errorMessage = '';
    try {
      this.entries = await firstValueFrom(this.api.getDailyJournalEntries());
    } catch {
      this.entries = [];
      this.errorMessage = 'Tagebuch konnte nicht geladen werden.';
    }
  }

  async addEntry(): Promise<void> {
    const text = this.entryText.trim();
    if (!this.entryDate || !text) return;

    this.errorMessage = '';
    try {
      const saved = await firstValueFrom(this.api.createDailyJournalEntry({
        entryDate: this.entryDate,
        entryText: text
      }));
      this.entries = [saved, ...this.entries]
        .sort((a, b) => `${b.entryDate} ${b.createdAt ?? ''}`.localeCompare(`${a.entryDate} ${a.createdAt ?? ''}`));
      this.entryText = '';
    } catch {
      this.errorMessage = 'Tagebuch-Eintrag konnte nicht gespeichert werden.';
    }
  }

  async deleteEntry(entry: DailyJournalEntry): Promise<void> {
    if (!entry.id) return;

    this.errorMessage = '';
    try {
      await firstValueFrom(this.api.deleteDailyJournalEntry(entry.id));
      this.entries = this.entries.filter((item) => item.id !== entry.id);
    } catch {
      this.errorMessage = 'Tagebuch-Eintrag konnte nicht gelöscht werden.';
    }
  }

  groups(): Array<{ date: string; entries: DailyJournalEntry[] }> {
    const groups = new Map<string, DailyJournalEntry[]>();
    this.entries.forEach((entry) => {
      const date = entry.entryDate || '-';
      groups.set(date, [...(groups.get(date) ?? []), entry]);
    });
    return Array.from(groups.entries())
      .sort(([a], [b]) => b.localeCompare(a))
      .map(([date, entries]) => ({
        date,
        entries: entries.slice().sort((a, b) => (b.createdAt ?? '').localeCompare(a.createdAt ?? ''))
      }));
  }

  private today(): string {
    return new Date().toISOString().slice(0, 10);
  }
}
